
/* injects from baggage-loader */

import StatusBarModule from './status-bar/status-bar.module';
import DialogBallonsModule from './dialog-ballons/dialog-ballons.module';
import ChromaPointerModule from './chroma-pointer/chroma-pointer.module';
import AbeldoChromaDialogModule from './abeldo-chroma-dialog-scene/abeldo-chroma-dialog-scene.module';
import GameplayInputRadioModule from './gameplay-input-radio/gameplay-input-radio.module';
import transitionZoomModule from './transition-zoom/transition-zoom.module';

const shared = angular.module('ui-module', [
  StatusBarModule.name,
  ChromaPointerModule.name,
  DialogBallonsModule.name,
  AbeldoChromaDialogModule.name,
  GameplayInputRadioModule.name,
  transitionZoomModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/index.js